import toast from "react-hot-toast";
import HttpClient from "./HttpClient";

export const BookingService = {
    createBookingTicketOnline: async (params) => {
        const res = await new HttpClient().post(
            "/booking/ticket/online",
            params
        );
        if (res.status === 200) {
            toast.success("Tạo booking thành công");
            return res.data;
        }
        toast.error("Tạo booking thất bại");
    },
    getBookingInfoByTransactionCode: async (params) => {
        const res = await new HttpClient().post(
            "/booking/ticket/get-booking-by-transaction-code",
            params
        );
        if (res.status === 200) {
            return res?.data?.data;
        }
    },
    // Lấy thông tin booking theo ID
    getBookingInfoById: async ({ booking_id }) => {
        const res = await new HttpClient().get(
            "/booking/ticket/get-full-info-booking-web",
            { params: { booking_id } }
        );

        if (res.status === 200) {
            return res?.data?.data;
        }
        return false;
    },
};
